var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChip5Dollars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 38.4 38.4",
    style: {
      enableBackground: "new 0 0 38.4 38.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#18930A;}\n\t.st1{fill:#106B05;}\n\t.st2{fill:#32D320;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 19.2,
    cy: 19.2,
    r: 19.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.2,9.6c1.7,0,3.3,0.3,4.8,0.9V0.6C22.5,0.2,20.9,0,19.2,0s-3.3,0.2-4.8,0.6v9.9C15.9,10,17.5,9.6,19.2,9.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.2,28.8c-1.7,0-3.3-0.3-4.8-0.9v9.9c1.5,0.4,3.1,0.6,4.8,0.6s3.3-0.2,4.8-0.6V28 C22.5,28.5,20.9,28.8,19.2,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.8,19.2c0,1.7-0.3,3.3-0.9,4.8h9.9c0.4-1.5,0.6-3.1,0.6-4.8s-0.2-3.3-0.6-4.8h-9.9 C28.5,15.9,28.8,17.5,28.8,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.6,19.2c0-1.7,0.3-3.3,0.9-4.8H0.6C0.2,16,0,17.6,0,19.2s0.2,3.3,0.6,4.8h9.9C9.9,22.5,9.6,20.9,9.6,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.2,33.6c-7.9,0-14.4-6.5-14.4-14.4S11.3,4.8,19.2,4.8s14.4,6.5,14.4,14.4S27.1,33.6,19.2,33.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.8,24.8V24c-1.7-0.1-2.8-0.9-3.2-1.9c-0.1-0.2-0.1-0.3-0.1-0.4c0-0.5,0.3-0.8,0.9-0.8 c0.4,0,0.7,0.2,0.9,0.6c0.2,0.5,0.6,0.9,1.5,1V20l-0.5-0.1c-1.8-0.4-2.7-1.2-2.7-2.6c0-1.6,1.3-2.7,3.2-2.8v-0.8 c0-0.2,0.1-0.3,0.3-0.3c0.2,0,0.3,0.1,0.3,0.3v0.8c1.6,0.1,2.7,0.9,3,1.9c0,0.1,0.1,0.3,0.1,0.4c0,0.4-0.3,0.7-0.8,0.7 c-0.4,0-0.7-0.2-0.9-0.6c-0.3-0.5-0.7-0.9-1.3-1v2.4l0.5,0.1c1.8,0.4,2.8,1.2,2.8,2.6c0,1.7-1.4,2.7-3.3,2.8v0.8 c0,0.2-0.1,0.3-0.3,0.3C14.9,25.1,14.8,25,14.8,24.8z M14.8,18.2V16c-0.9,0.1-1.3,0.5-1.3,1.1S13.8,18,14.8,18.2z M15.5,20.2v2.3 c1-0.1,1.4-0.5,1.4-1.1C16.9,20.7,16.5,20.4,15.5,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19.8,22.6c-0.1-0.2-0.2-0.4-0.2-0.7c0-0.5,0.3-0.8,0.8-0.8c0.4,0,0.7,0.1,0.9,0.5c0.3,0.7,0.9,1.1,1.8,1.1 c1.1,0,1.8-0.8,1.8-1.8c0-1-0.8-1.7-1.8-1.7c-0.6,0-1.1,0.2-1.4,0.6c-0.4,0.4-0.6,0.5-1,0.5c-0.7,0-1-0.5-1-1c0,0,0,0,0-0.1 l0.3-3.5c0.1-0.8,0.5-1.1,1.3-1.1h4.2c0.5,0,0.8,0.3,0.8,0.8c0,0.5-0.3,0.8-0.8,0.8h-3.8l-0.2,2.7h0c0.4-0.6,1.2-1,2.2-1 c1.8,0,3.2,1.3,3.2,3.1c0,2.1-1.5,3.5-3.7,3.5C21.6,24.3,20.3,23.6,19.8,22.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip5Dollars);
export default __webpack_public_path__ + "static/media/chip_5-dollars.c835f63b5aed0ea883952b7b6e7837ce.svg";
export { ForwardRef as ReactComponent };